import Immutable from 'immutable';

const TaskCentreRecord = Immutable.Record({
  id: undefined,
  name: undefined,
});

export default class TaskCentre extends TaskCentreRecord { }



// WEBPACK FOOTER //
// ./data/Tasks/TaskCentre/model.js